import Fnc from './library/Functions';

export const Config = {
  envs: [
    {
      "type": "LOCAL",
      "domain": "https://uat-www.italiaonline.it",
      "apiPath": "https://forlocalhost.italiaonline.it/services_v1",
      "bypassCaptchaToken": "-KaPdSgV",
      "apiLbsPath": "https://services.tuttocitta.it/lbs",
      "areaClientiPath": "https://test-portaleclienti.italiaonline.it/",
      "areaClientiSDIYFPath": "https://test-portaleclienti.italiaonline.it/contratto/#commissioneaddOn#/gestisci-prodotti/sito/wizard",
      "areaClientiCMFTFPath": "https://test-portaleclienti.italiaonline.it/contratto/#commissioneaddOn#/gestisci-prodotti/multichannel/nuova-campagna",
      "logsLevel": Fnc.LogLvl.DEBUG,
      "businessHome": "/",
      "basketHome": "/carrello",
      "registrationEnd": "/carrello/registrazione/end",
      "registrationSito": "/carrello/registrazione/sito",
      "registrationCampagna": "/carrello/registrazione/campagna",
      "zuoraParam": {
        'tenantId': '2000552',
        'id': '8adc8ea17e0ebc76017e1f1201386d34',
        'style': 'inline',
        'submitEnabled': 'false',
        //  'authorizationAmount': '1',
        'locale': 'it',
        'url': 'https://sandbox.eu.zuora.com/apps/PublicHostedPageLite.do',
        'param_supportedTypes': 'AmericanExpress,Visa,MasterCard',
        'field_passthrough1': '',
      },
      "paypalParam": { environment: 'sandbox' },
      "gaMeasurementId": "G-PZNSHBKJ0M",
      "gaEnv": "dev",
      "courtesyPage" : "/manutenzione/"
    },
    {
      "type": "UAT",
      "domain": "https://uat-www.italiaonline.it",
      "apiPath": "/services_v1",
      "bypassCaptchaToken": "-KaPdSgV",
      "apiLbsPath": "https://services.tuttocitta.it/lbs",
      "areaClientiPath": "https://test-portaleclienti.italiaonline.it/",
      "areaClientiSDIYFPath": "https://test-portaleclienti.italiaonline.it/contratto/#commissioneaddOn#/gestisci-prodotti/sito/wizard",
      "areaClientiCMFTFPath": "https://test-portaleclienti.italiaonline.it/contratto/#commissioneaddOn#/gestisci-prodotti/multichannel/nuova-campagna",
      "logsLevel": Fnc.LogLvl.DEBUG,
      "businessHome": "/",
      "basketHome": "/carrello",
      "registrationEnd": "/carrello/registrazione/end",
      "registrationSito": "/carrello/registrazione/sito",
      "registrationCampagna": "/carrello/registrazione/campagna",
      "zuoraParam": {
        'tenantId': '2000552',
        'id': '8adc8ea17e0ebc76017e1f1201386d34',
        'style': 'inline',
        'submitEnabled': 'false',
        //  'authorizationAmount': '1',
        'locale': 'it',
        'url': 'https://sandbox.eu.zuora.com/apps/PublicHostedPageLite.do',
        'param_supportedTypes': 'AmericanExpress,Visa,MasterCard',
        'field_passthrough1': '',
      },
      "paypalParam": { environment: 'sandbox' },
      "gaMeasurementId": "G-PZNSHBKJ0M",
      "gaEnv": "test",
      "courtesyPage" : "/manutenzione/"
    },
    {
      "type": "PRODUCTION",
      "domain": "https://www.italiaonline.it",
      "apiPath": "/services_v1",
      "bypassCaptchaToken": "",
      "apiLbsPath": "https://services.tuttocitta.it/lbs",
      "areaClientiPath": "https://areaclienti.italiaonline.it/",
      "areaClientiSDIYFPath": "https://areaclienti.italiaonline.it/contratto/#commissioneaddOn#/gestisci-prodotti/sito/wizard",
      "areaClientiCMFTFPath": "https://areaclienti.italiaonline.it/contratto/#commissioneaddOn#/gestisci-prodotti/multichannel/nuova-campagna",
      "logsLevel": Fnc.LogLvl.DEBUG,
      "businessHome": "/",
      "basketHome": "/carrello",
      "registrationEnd": "/carrello/registrazione/end",
      "registrationSito": "/carrello/registrazione/sito",
      "registrationCampagna": "/carrello/registrazione/campagna",
      "zuoraParam": {
        'tenantId': '3000268',
        'id': '8a28f1aa70c838510170c9bf10210bb5',
        'style': 'inline',
        'submitEnabled': 'false',
        'locale': 'it',
        'url': 'https://eu.zuora.com/apps/PublicHostedPageLite.do',
        'param_supportedTypes': 'AmericanExpress,Visa,MasterCard',
        'field_passthrough1': '',
      }
      , "paypalParam": { environment: 'production' },
      "gaMeasurementId": "G-PZNSHBKJ0M",
      "gaEnv": "online",
      "courtesyPage" : "/manutenzione/"
    }
  ],
  stepList: [
    { "idx": -1, "path": "/carrello/err", "re": "^/carrello/err$", "desc": "Errore", "default": false, "enabled": false, "withBasket": false, bskType: Fnc.BasketType.BOTH, "gaCheckoutStep": -1, "basketTitle" : "Completa il tuo acquisto" },
    { "idx": -2, "path": "/carrello/empty", "re": "^/carrello/empty$", "desc": "Carrello Vuoto", "default": false, "enabled": false, "withBasket": false, bskType: Fnc.BasketType.BOTH, "gaCheckoutStep": -1, "basketTitle" : "Completa il tuo acquisto" },
    { "idx": 9, "path": "/carrello/fill", "re": "^/carrello/fill$", "desc": "Personalizzazione", "default": false, "enabled": false, "withBasket": true, bskType: Fnc.BasketType.PAY, "gaCheckoutStep": -1, "basketTitle" : "Completa il tuo acquisto" },
    { "idx": 10, "path": "/carrello", "re": "^/carrello[/]?$", "desc": "Dati fatturazione", "descPrev": "Dati contatto", "default": true, "enabled": true, "withBasket": true, bskType: Fnc.BasketType.BOTH, "gaCheckoutStep": 1, "basketTitle" : "Completa il tuo acquisto" },
    { "idx": 11, "path": "/carrello/pay", "re": "^/carrello/pay$", "desc": "Dati Pagamento", "default": false, "enabled": true, "withBasket": true, bskType: Fnc.BasketType.PAY, "gaCheckoutStep": 2, "basketTitle" : "Completa il tuo acquisto" },
    { "idx": 12, "path": "/carrello/end", "re": "^/carrello/end$", "desc": "Riepilogo Finale", "descPrev": "Riepilogo Finale", "default": false, "enabled": true, "withBasket": false, bskType: Fnc.BasketType.BOTH, "gaCheckoutStep": 3, "basketTitle" : "Acquisto completato" }
  ],
  reCaptchaKey: "6LdgfboUAAAAADM14NWgB9xQ9M2U-Jp1eo-AThSm",
	version: "1.1.3"
};


